var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 464,
    viewBox: "0 0 473 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.849 455H139.277L129.177 439.602C128.585 438.702 128.175 438.024 127.947 437.568H127.878C127.97 438.434 128.015 439.756 128.015 441.533V455H122.803V430.493H128.75L138.474 445.413C138.918 446.085 139.329 446.751 139.705 447.412H139.773C139.682 446.842 139.636 445.72 139.636 444.045V430.493H144.849V455ZM158.264 455.427C155.347 455.427 153.052 454.613 151.377 452.983C149.714 451.343 148.882 449.121 148.882 446.318C148.882 443.424 149.748 441.163 151.479 439.534C153.211 437.893 155.553 437.073 158.503 437.073C161.409 437.073 163.687 437.893 165.339 439.534C166.991 441.163 167.817 443.322 167.817 446.011C167.817 448.916 166.963 451.212 165.254 452.898C163.556 454.584 161.226 455.427 158.264 455.427ZM158.401 441.208C157.125 441.208 156.134 441.647 155.427 442.524C154.721 443.402 154.368 444.644 154.368 446.25C154.368 449.611 155.723 451.292 158.435 451.292C161.021 451.292 162.314 449.565 162.314 446.113C162.314 442.843 161.01 441.208 158.401 441.208ZM181.523 455V430.493H190.205C198.91 430.493 203.262 434.475 203.262 442.439C203.262 446.256 202.071 449.303 199.69 451.582C197.32 453.861 194.159 455 190.205 455H181.523ZM187.043 434.988V450.522H189.778C192.17 450.522 194.045 449.805 195.4 448.369C196.768 446.934 197.451 444.98 197.451 442.507C197.451 440.172 196.773 438.337 195.417 437.004C194.073 435.66 192.182 434.988 189.744 434.988H187.043ZM221.36 455H216.25V452.488H216.182C215.008 454.447 213.271 455.427 210.969 455.427C209.272 455.427 207.933 454.949 206.953 453.992C205.985 453.023 205.5 451.736 205.5 450.129C205.5 446.734 207.511 444.775 211.533 444.25L216.284 443.618C216.284 441.704 215.247 440.747 213.174 440.747C211.089 440.747 209.106 441.368 207.227 442.61V438.542C207.979 438.155 209.004 437.813 210.303 437.517C211.613 437.221 212.804 437.073 213.875 437.073C218.865 437.073 221.36 439.562 221.36 444.541V455ZM216.284 447.891V446.711L213.105 447.122C211.351 447.349 210.474 448.141 210.474 449.497C210.474 450.112 210.684 450.619 211.106 451.018C211.539 451.405 212.12 451.599 212.849 451.599C213.863 451.599 214.689 451.252 215.327 450.557C215.965 449.85 216.284 448.962 216.284 447.891ZM236.211 454.795C235.413 455.216 234.211 455.427 232.605 455.427C228.8 455.427 226.897 453.451 226.897 449.497V441.482H224.06V437.5H226.897V433.723L232.28 432.185V437.5H236.211V441.482H232.28V448.557C232.28 450.38 233.004 451.292 234.451 451.292C235.02 451.292 235.607 451.126 236.211 450.796V454.795ZM253.831 455H248.721V452.488H248.652C247.479 454.447 245.741 455.427 243.44 455.427C241.742 455.427 240.404 454.949 239.424 453.992C238.455 453.023 237.971 451.736 237.971 450.129C237.971 446.734 239.982 444.775 244.004 444.25L248.755 443.618C248.755 441.704 247.718 440.747 245.645 440.747C243.56 440.747 241.577 441.368 239.697 442.61V438.542C240.449 438.155 241.475 437.813 242.773 437.517C244.084 437.221 245.274 437.073 246.345 437.073C251.335 437.073 253.831 439.562 253.831 444.541V455ZM248.755 447.891V446.711L245.576 447.122C243.822 447.349 242.944 448.141 242.944 449.497C242.944 450.112 243.155 450.619 243.577 451.018C244.01 451.405 244.591 451.599 245.32 451.599C246.334 451.599 247.16 451.252 247.798 450.557C248.436 449.85 248.755 448.962 248.755 447.891ZM282.473 434.988H273.826V441.003H281.772V445.481H273.826V455H268.306V430.493H282.473V434.988ZM294.333 455.427C291.417 455.427 289.121 454.613 287.446 452.983C285.783 451.343 284.951 449.121 284.951 446.318C284.951 443.424 285.817 441.163 287.549 439.534C289.281 437.893 291.622 437.073 294.573 437.073C297.478 437.073 299.757 437.893 301.409 439.534C303.061 441.163 303.887 443.322 303.887 446.011C303.887 448.916 303.032 451.212 301.323 452.898C299.626 454.584 297.296 455.427 294.333 455.427ZM294.47 441.208C293.194 441.208 292.203 441.647 291.497 442.524C290.79 443.402 290.437 444.644 290.437 446.25C290.437 449.611 291.793 451.292 294.504 451.292C297.091 451.292 298.384 449.565 298.384 446.113C298.384 442.843 297.079 441.208 294.47 441.208ZM324.019 455H318.635V452.334H318.55C317.217 454.396 315.434 455.427 313.201 455.427C309.145 455.427 307.117 452.972 307.117 448.062V437.5H312.5V447.583C312.5 450.055 313.48 451.292 315.439 451.292C316.408 451.292 317.183 450.955 317.764 450.283C318.345 449.6 318.635 448.677 318.635 447.515V437.5H324.019V455ZM345.483 455H340.1V445.276C340.1 442.564 339.132 441.208 337.195 441.208C336.261 441.208 335.492 441.567 334.888 442.285C334.284 443.003 333.982 443.914 333.982 445.02V455H328.582V437.5H333.982V440.269H334.05C335.338 438.138 337.212 437.073 339.673 437.073C343.547 437.073 345.483 439.477 345.483 444.285V455ZM366.897 455H361.497V452.59H361.428C360.198 454.482 358.392 455.427 356.011 455.427C353.823 455.427 352.063 454.658 350.73 453.12C349.397 451.571 348.73 449.412 348.73 446.643C348.73 443.749 349.465 441.431 350.935 439.688C352.405 437.944 354.33 437.073 356.711 437.073C358.967 437.073 360.54 437.882 361.428 439.5H361.497V429.092H366.897V455ZM361.599 446.489V445.173C361.599 444.034 361.269 443.088 360.608 442.336C359.947 441.584 359.087 441.208 358.027 441.208C356.831 441.208 355.897 441.681 355.225 442.627C354.552 443.561 354.216 444.849 354.216 446.489C354.216 448.027 354.541 449.212 355.19 450.044C355.84 450.876 356.74 451.292 357.891 451.292C358.984 451.292 359.873 450.853 360.557 449.976C361.252 449.098 361.599 447.936 361.599 446.489Z",
    fill: "#D84141"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1158_1505)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.38 202.64C448.8 185.15 428.17 175.75 409.04 165.83C389.91 155.92 370.14 143.34 362.37 123.25C351.2 94.3601 368.67 59.8901 356.28 31.5001C345.51 6.81006 314.32 -4.09994 287.94 1.40006C261.56 6.90006 239.67 25.2301 221.89 45.4801C204.12 65.7301 189.22 88.5101 169.97 107.36C142.22 134.53 106.84 152.21 73.21 171.64C48.47 185.94 23.35 202.47 9.77001 227.61C-0.639988 246.89 -3.13999 270.57 4.25001 291.2C11.64 311.83 29.14 328.85 50.33 334.47C83.16 343.17 116.66 324.92 144.73 305.81C172.8 286.69 202.64 265.05 236.59 266.12C270.59 267.19 299.36 290.89 331.93 300.69C367.56 311.41 409.34 302.01 443.19 288.12C475.02 275.06 480.14 228.74 461.38 202.64Z",
    fill: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8499 352.73C73.0999 351.99 61.3399 351.25 49.5899 350.51C45.7199 350.27 41.6099 350.07 38.1899 351.9C31.8399 355.3 30.7499 364.58 34.1999 370.9C37.6599 377.22 44.2599 381.11 50.7799 384.17C59.2899 388.17 68.3499 391.32 77.7299 391.9C87.11 392.47 96.8999 390.26 104.29 384.45C109.81 380.1 118.46 368.07 114.1 360.71C109.79 353.43 91.9699 353.19 84.8499 352.74V352.73Z",
    fill: "#F30000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.24 73.1396H105.06C98.8084 73.1396 93.7402 78.2078 93.7402 84.4596V257.63C93.7402 263.882 98.8084 268.95 105.06 268.95H367.24C373.492 268.95 378.56 263.882 378.56 257.63V84.4596C378.56 78.2078 373.492 73.1396 367.24 73.1396Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.24 257.429C360.24 259.999 358.16 262.079 355.59 262.079C353.02 262.079 350.94 259.999 350.94 257.429C350.94 254.859 353.02 252.779 355.59 252.779C358.16 252.779 360.24 254.859 360.24 257.429Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.39 89.5596H104.92V242.49H367.39V89.5596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.01 103.829C124.01 106.069 122.19 107.879 119.96 107.879C117.73 107.879 115.91 106.059 115.91 103.829C115.91 101.599 117.73 99.7793 119.96 99.7793C122.19 99.7793 124.01 101.599 124.01 103.829Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 103.829C138.5 106.069 136.68 107.879 134.45 107.879C132.22 107.879 130.4 106.059 130.4 103.829C130.4 101.599 132.22 99.7793 134.45 99.7793C136.68 99.7793 138.5 101.599 138.5 103.829Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 103.829C153 106.069 151.18 107.879 148.95 107.879C146.72 107.879 144.9 106.059 144.9 103.829C144.9 101.599 146.72 99.7793 148.95 99.7793C151.18 99.7793 153 101.599 153 103.829Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72 124.45L119.57 133.76H169.48C170.91 133.76 172.08 134.92 172.08 136.36V201.91C172.08 203.34 170.92 204.51 169.48 204.51H73.7504C72.3204 204.51 71.1504 203.35 71.1504 201.91V125.65C71.1504 124.22 72.3104 123.05 73.7504 123.05H112.41C113.38 123.05 114.27 123.59 114.71 124.45H114.72Z",
    fill: "#FE9797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.75 123.06H112.41C113.38 123.06 114.27 123.6 114.71 124.46L119.56 133.77H169.47C170.9 133.77 172.07 134.93 172.07 136.37V201.92",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.621 188.63C131.893 188.63 140.221 180.302 140.221 170.03C140.221 159.757 131.893 151.43 121.621 151.43C111.348 151.43 103.021 159.757 103.021 170.03C103.021 180.302 111.348 188.63 121.621 188.63Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55 176.95L122.63 170.03L129.55 163.11C129.83 162.83 129.83 162.38 129.55 162.1C129.27 161.82 128.82 161.82 128.54 162.1L121.62 169.02L114.7 162.1C114.42 161.82 113.97 161.82 113.69 162.1C113.41 162.38 113.41 162.83 113.69 163.11L120.61 170.03L113.69 176.95C113.41 177.23 113.41 177.68 113.69 177.96C113.97 178.24 114.42 178.24 114.7 177.96L121.62 171.04L128.54 177.96C128.82 178.24 129.27 178.24 129.55 177.96C129.83 177.68 129.83 177.23 129.55 176.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23 124.45L234.08 133.76H283.99C285.42 133.76 286.59 134.92 286.59 136.36V201.91C286.59 203.34 285.43 204.51 283.99 204.51H188.26C186.83 204.51 185.66 203.35 185.66 201.91V125.65C185.66 124.22 186.82 123.05 188.26 123.05H226.92C227.89 123.05 228.78 123.59 229.22 124.45H229.23Z",
    fill: "#FE9797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.271 123.06H226.93C227.9 123.06 228.79 123.6 229.23 124.46L234.081 133.77H283.99C285.42 133.77 286.59 134.93 286.59 136.37V201.92",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.13 188.63C246.403 188.63 254.73 180.302 254.73 170.03C254.73 159.757 246.403 151.43 236.13 151.43C225.858 151.43 217.53 159.757 217.53 170.03C217.53 180.302 225.858 188.63 236.13 188.63Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.06 176.95L237.14 170.03L244.06 163.11C244.34 162.83 244.34 162.38 244.06 162.1C243.78 161.82 243.33 161.82 243.05 162.1L236.13 169.02L229.21 162.1C228.93 161.82 228.48 161.82 228.2 162.1C227.92 162.38 227.92 162.83 228.2 163.11L235.12 170.03L228.2 176.95C227.92 177.23 227.92 177.68 228.2 177.96C228.48 178.24 228.93 178.24 229.21 177.96L236.13 171.04L243.05 177.96C243.33 178.24 243.78 178.24 244.06 177.96C244.34 177.68 244.34 177.23 244.06 176.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.751 124.45L348.601 133.76H398.511C399.941 133.76 401.111 134.92 401.111 136.36V201.91C401.111 203.34 399.951 204.51 398.511 204.51H302.781C301.351 204.51 300.181 203.35 300.181 201.91V125.65C300.181 124.22 301.341 123.05 302.781 123.05H341.441C342.411 123.05 343.301 123.59 343.741 124.45H343.751Z",
    fill: "#FE9797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.791 123.06H341.451C342.421 123.06 343.311 123.6 343.751 124.46L348.601 133.77H398.511C399.941 133.77 401.111 134.93 401.111 136.37V201.92",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.651 188.63C360.923 188.63 369.251 180.302 369.251 170.03C369.251 159.757 360.923 151.43 350.651 151.43C340.378 151.43 332.051 159.757 332.051 170.03C332.051 180.302 340.378 188.63 350.651 188.63Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.581 176.95L351.661 170.03L358.581 163.11C358.861 162.83 358.861 162.38 358.581 162.1C358.301 161.82 357.851 161.82 357.571 162.1L350.651 169.02L343.731 162.1C343.451 161.82 343.001 161.82 342.721 162.1C342.441 162.38 342.441 162.83 342.721 163.11L349.641 170.03L342.721 176.95C342.441 177.23 342.441 177.68 342.721 177.96C343.001 178.24 343.451 178.24 343.731 177.96L350.651 171.04L357.571 177.96C357.851 178.24 358.301 178.24 358.581 177.96C358.861 177.68 358.861 177.23 358.581 176.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91 89.1192C352.91 89.1192 343.89 75.9592 332.6 82.5192C318.47 90.7392 335.53 110.309 325.09 115.969C314.65 121.629 303.85 122.069 300.84 137.739C296.91 158.219 333.95 187.019 365.28 168.789C396.61 150.559 385.46 116.439 370.75 109.649C353.05 101.479 352.9 89.1192 352.9 89.1192H352.91Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.729 120.02V138.1C346.729 140.44 347.679 142.56 349.219 144.1C350.749 145.64 352.869 146.59 355.209 146.59C359.889 146.59 363.689 142.79 363.689 138.11V120.03H346.739L346.729 120.02Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6 114.429C375.9 117.869 372.54 120.079 369.1 119.379C365.66 118.679 363.45 115.319 364.15 111.879C364.85 108.439 368.21 106.229 371.65 106.929C375.09 107.629 377.3 110.989 376.6 114.429Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.86 112.02L369.83 115.43",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65 113.16C339.95 116.6 336.59 118.81 333.15 118.11C329.71 117.41 327.5 114.05 328.2 110.61C328.9 107.17 332.26 104.96 335.7 105.66C339.14 106.36 341.35 109.72 340.65 113.16Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.03 111.879C335.03 111.879 331.4 107.909 332.67 98.4893H337.76L335.02 111.879H335.03Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.48 114.679L330.55 109.909",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.949 87.0596C341.829 87.0596 334.439 94.4496 334.439 103.57V117.14C334.439 117.48 334.469 117.81 334.509 118.14C334.749 119.74 335.569 121.21 336.839 122.26L343.529 127.82C345.559 129.51 348.399 129.84 350.769 128.65L363.809 122.11C366.059 120.97 367.469 118.67 367.469 116.17V103.58C367.469 94.4596 360.079 87.0696 350.959 87.0696L350.949 87.0596Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.69 124.58L351.11 128.38C349.83 129.02 348.41 129.36 346.98 129.36H346.42",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.36 87.0596L344.16 115.98H349.43",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43 108.06V116.53C334.63 116.56 334.83 116.57 335.04 116.57C337.4 116.57 339.32 114.66 339.32 112.29C339.32 109.92 337.4 108.02 335.04 108.02C334.83 108.02 334.62 108.04 334.43 108.06Z",
    fill: "#CB705D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.83 116.58C361.194 116.58 363.11 114.663 363.11 112.3C363.11 109.936 361.194 108.02 358.83 108.02C356.466 108.02 354.55 109.936 354.55 112.3C354.55 114.663 356.466 116.58 358.83 116.58Z",
    fill: "#CB705D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.58 108.209C337.58 109.689 338.24 110.889 339.06 110.889C339.88 110.889 340.54 109.689 340.54 108.209C340.54 106.729 339.88 105.529 339.06 105.529C338.24 105.529 337.58 106.729 337.58 108.209Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.05 108.209C353.05 109.689 353.71 110.889 354.53 110.889C355.35 110.889 356.01 109.689 356.01 108.209C356.01 106.729 355.35 105.529 354.53 105.529C353.71 105.529 353.05 106.729 353.05 108.209Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46 102.02V112.73C367.46 112.73 363.21 108.95 363.33 101.52L367.46 102.02Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.02 96.849C338.68 94.809 337.38 94.559 336.52 97.279L340.02 96.849Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.349 97.6191C358.149 95.1891 357.129 94.3491 355.069 96.3191L358.349 97.6191Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.699 84.7896C340.989 78.2296 352.919 89.1196 352.919 89.1196C352.919 89.1196 347.159 101.52 370.759 109.65C374.649 110.99 379.489 117.51 381.829 121.24C381.829 121.24 376.659 106.32 375.029 96.6696C373.389 87.0096 364.809 88.4996 364.809 88.4996C364.809 88.4996 359.609 75.7996 345.229 75.8596C335.269 75.8996 329.689 84.7896 329.689 84.7896H329.699Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.41 122.409C346.79 117.129 344.17 122.409 344.17 122.409H349.41Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.77 197.049L317.63 175.239L329.14 186.409C320.47 194.609 309.7 200.229 298.03 202.659L276.06 206.069L276.77 197.039V197.049Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71 185.109C320.51 188.619 325.63 189.199 329.14 186.409L360.76 161.229C364.27 158.429 364.85 153.309 362.06 149.799C359.26 146.289 354.14 145.709 350.63 148.499L317.64 175.239C317.64 175.239 314.91 181.599 317.71 185.109Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38 166.449L333.98 165.419L350.41 170.769L333.98 171.409L318.38 166.449Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5 151.879L320.94 172.329L345.56 175.729L341.96 139.109L335.23 140.029C329.09 140.869 324.27 145.729 323.5 151.889V151.879Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38 166.449L333.98 171.409L350.41 170.769L347.26 179.969L332.84 179.219L317.54 174.439L318.38 166.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.97 204.02H368.52L389.44 163.45C392.89 156.77 390.01 148.56 383.15 145.49L361.54 135.81L341.96 139.12C335.18 140.26 330.44 146.45 331.1 153.29L335.98 204.03L335.97 204.02Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.73 150.46L342.3 134.49L369.7 131.83L367.15 150.46H344.73Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.85 143.189C364.63 150.989 359.26 166.789 351.7 169.199C351.29 169.329 350.89 169.399 350.51 169.399C349.59 169.399 348.77 169.019 348 168.229C344.09 164.249 343.06 151.919 342.8 144.649C344.86 149.139 348.47 151.759 352.93 151.759C357.77 151.759 362.7 148.689 366.86 143.199M368.73 139.029C363.94 147.229 358.02 151.009 352.93 151.009C347.57 151.009 343.15 146.799 341.97 139.119C341.97 139.119 341.4 170.159 350.51 170.159C350.96 170.159 351.43 170.079 351.93 169.929C362.52 166.559 368.73 139.039 368.73 139.039V139.029Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.78 393.26H312.38L319.06 342.52H335.46L328.78 393.26Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.34 393.179H311.87L314.83 369.039L333.13 370.439L330.34 393.179Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78 408.25H289.87L290.97 404.51C291.33 403.29 291.87 402.16 292.56 401.13C294.02 398.95 296.15 397.27 298.69 396.38L299.82 395.98C300.93 395.59 301.98 395.07 302.95 394.45C303.78 393.91 304.56 393.3 305.25 392.61C306.77 391.13 307.97 389.31 308.74 387.26H332.29L331.9 401.13L331.79 408.25H331.78Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.69 389.63H307.41",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.551 392.51H305.271",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.921 398.169C323.941 398.729 323.491 399.189 322.931 399.189C322.371 399.189 321.891 398.729 321.881 398.169C321.861 397.609 322.311 397.149 322.871 397.149C323.431 397.149 323.911 397.609 323.921 398.169Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.921 398.169C318.941 398.729 318.491 399.189 317.931 399.189C317.371 399.189 316.891 398.729 316.881 398.169C316.861 397.609 317.311 397.149 317.871 397.149C318.431 397.149 318.911 397.609 318.921 398.169Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78 408.25H289.87L290.97 404.51C291.33 403.29 291.87 402.16 292.56 401.13H331.9L331.79 408.25H331.78Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.01 404.689H305.66",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4 408.249H289.88L290.98 404.509C291.34 403.289 291.88 402.159 292.57 401.129C294.03 398.949 296.16 397.269 298.7 396.379L299.83 395.979C300.94 395.589 301.99 395.069 302.96 394.449C308.41 396.969 312.48 402.119 313.41 408.249H313.4Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74 387.26L308.2 385.17C307.82 383.7 308.89 382.31 310.4 382.31H312.5C314.16 382.31 315.73 383.15 316.67 384.55L318.5 387.26H308.74Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.45 195.96L332.21 193.51L336.17 204.97L373.83 204.56L377.45 195.96Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.17 204.97C336.17 204.97 320.67 219.3 319.75 244.85H389.05C389.05 220.83 373.83 204.56 373.83 204.56L336.17 204.97Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.05 214.58H365.18C365.18 214.58 370.54 226.95 381.24 227.76",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76 214.58H334.75C334.75 214.58 332.46 226.29 322.73 227.76",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.07 205.74L350.12 224.7C350.12 224.7 353.64 222.83 352.89 216.52",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.72 206.939H371.59V203.019H361.72V206.939Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74 206.939H341.17V203.019H337.74V206.939Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.44 206.939H358.98V203.019H343.44V206.939Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.35 207.729H353V202.229H346.35V207.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.28 393.219L375.88 393.959L367.49 338.899L383.89 338.159L392.28 393.219Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22 393.179L374.77 394.009L371.59 368.919L390.01 370.029L393.22 393.179Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.82 408.25H354.91L355.28 404.51C355.4 403.29 355.72 402.16 356.21 401.13C357.24 398.95 359.05 397.27 361.41 396.38L362.47 395.98C363.51 395.59 364.45 395.07 365.3 394.45C366.03 393.91 366.68 393.3 367.25 392.61C368.48 391.13 369.33 389.31 369.7 387.26H393.25L395.56 401.13L396.83 408.25H396.82Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1 389.63H368.83",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.53 392.51H367.25",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 398.169C387.13 398.729 386.77 399.189 386.21 399.189C385.65 399.189 385.09 398.729 384.96 398.169C384.83 397.609 385.19 397.149 385.75 397.149C386.31 397.149 386.87 397.609 387 398.169Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 398.169C382.13 398.729 381.77 399.189 381.21 399.189C380.65 399.189 380.08 398.729 379.96 398.169C379.83 397.609 380.19 397.149 380.75 397.149C381.31 397.149 381.87 397.609 382 398.169Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.82 408.25H354.91L355.28 404.51C355.4 403.29 355.72 402.16 356.21 401.13H395.55L396.82 408.25Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.69 404.689H396.05",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.43 408.249H354.91L355.28 404.509C355.4 403.289 355.72 402.159 356.21 401.129C357.24 398.949 359.05 397.269 361.41 396.379L362.47 395.979C363.51 395.589 364.45 395.069 365.3 394.449C371.24 396.969 376.31 402.119 378.43 408.249Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.7 387.26L368.76 385.17C368.1 383.7 368.9 382.31 370.4 382.31H372.5C374.16 382.31 375.89 383.15 377.1 384.55L379.46 387.26H369.7Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.87 243.619L342.99 363.709H308.68L319.85 244.109L352.87 243.619Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63 298.659L395.71 363.709H361.4L350.62 299.149L383.63 298.659Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63 298.66C383.63 298.66 389.06 263 389.03 244.67H354.72L350.62 299.15L383.63 298.66Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.77 157.05C324.14 174.26 324.74 182.5 339.02 188.81L335.77 157.05Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63 171.41L334.04 159.69L331.09 153.29",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.82 193.09L287.41 206.57C279.35 209.85 273.85 212.51 273.85 212.51C269.8 211.19 266.76 208.12 264.78 205.45L273.91 200.25C269.58 200.87 265.59 202.77 263.65 203.82C262.52 202.07 261.96 200.78 261.96 200.78C271.11 195.54 278.81 193.09 278.81 193.09H278.82Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71 207.769C273.92 204.499 277.32 202.879 277.32 202.879",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.03 210.399L279.39 205.779",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4 229.259C293.33 232.329 288.36 232.329 285.29 229.259L262.38 206.349L273.49 195.239L296.4 218.149C299.47 221.219 299.47 226.189 296.4 229.259Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.26 209.359L281.88 225.859",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M237.06 184.229C238.14 185.309 238.14 187.059 237.06 188.139C235.98 189.219 234.23 189.219 233.15 188.139C232.07 187.059 232.07 185.309 233.15 184.229C234.23 183.149 235.98 183.149 237.06 184.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.487 196.744L263.891 187.339C265.101 186.13 267.066 186.13 268.276 187.339L274.123 193.187C275.332 194.396 275.332 196.362 274.123 197.571L264.719 206.975C263.51 208.185 261.544 208.185 260.335 206.975L254.487 201.128C253.278 199.918 253.278 197.953 254.487 196.744Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88 187.349C265.08 186.149 267.05 186.149 268.26 187.349L274.11 193.199C275.31 194.399 275.31 196.369 274.11 197.579L264.71 206.979",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91 144.729C199.44 157.629 198.97 179.079 211.87 192.559C224.77 206.029 246.22 206.499 259.7 193.599C273.17 180.699 273.64 159.249 260.74 145.769C247.84 132.299 226.39 131.829 212.91 144.729ZM254.48 151.769C264.07 161.789 263.73 177.749 253.7 187.339C243.68 196.929 227.72 196.589 218.13 186.559C208.54 176.539 208.88 160.579 218.91 150.989C228.93 141.399 244.89 141.739 254.48 151.769Z",
    fill: "#969696",
    stroke: "#1D1615",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M235.95 195.699C250.801 195.699 262.84 183.66 262.84 168.809C262.84 153.958 250.801 141.919 235.95 141.919C221.099 141.919 209.06 153.958 209.06 168.809C209.06 183.66 221.099 195.699 235.95 195.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M225.66 183.43C231.343 183.43 235.95 178.823 235.95 173.14C235.95 167.457 231.343 162.85 225.66 162.85C219.977 162.85 215.37 167.457 215.37 173.14C215.37 178.823 219.977 183.43 225.66 183.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M248.31 156.449C250.53 158.669 252.03 161.339 252.8 164.169L257.7 161.489C256.61 158.229 254.77 155.169 252.18 152.579C243.22 143.619 228.69 143.619 219.73 152.579L223.59 156.439C230.42 149.609 241.49 149.609 248.32 156.439L248.31 156.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.26 146.119C200.73 158.649 200.73 178.969 213.26 191.509C225.79 204.039 246.11 204.039 258.65 191.509C271.18 178.979 271.18 158.659 258.65 146.119C246.12 133.589 225.8 133.589 213.26 146.119ZM254.97 187.829C244.47 198.329 227.44 198.329 216.94 187.829C206.44 177.329 206.44 160.299 216.94 149.799C227.44 139.299 244.47 139.299 254.97 149.799C265.47 160.299 265.47 177.329 254.97 187.829Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.89 173.14C252.14 176.09 250.62 178.87 248.31 181.18L252.17 185.04C255.55 181.66 257.65 177.5 258.48 173.14H252.88H252.89Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.35 192.039L268.97 189.819C268.72 192.449 270.65 194.789 273.28 195.039L276.54 195.349L279.98 199.379C285.76 214.859 296.64 202.299 296.64 202.299L292.35 192.039Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93 203.569C281.03 205.449 279.42 196.089 279.42 196.089L273.29 195.039",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74 363.709L349.67 240.979H355.68",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.59 206.93C371.59 206.93 386.12 227.22 383.12 249.44C380.12 271.66 377.45 298.66 377.45 298.66L390.9 363.72",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66 374.7L372.23 374",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13 374.349L314.36 372.819",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.05 177.589C335.73 181.759 340.47 183.779 344.63 182.099L383.62 166.959C387.79 165.279 389.81 160.539 388.13 156.379C386.45 152.209 381.71 150.189 377.55 151.869L340.06 166.769C337.05 168.009 334.67 170.549 333.9 173.709C333.59 174.989 333.54 176.349 334.04 177.599L334.05 177.589Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6 170.859L364.35 176.679L360.14 155.049L377.24 147.489C384.43 144.309 392.51 149.549 392.55 157.409C392.55 158.929 392.28 160.439 391.65 161.819C389.71 166.059 386.09 169.349 381.6 170.869V170.859Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.599 178.109L365.399 163.209L362.449 152.139L353.979 156.919L362.899 180.399L370.599 178.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25 138.569C350.5 134.089 358.4 133.159 358.4 133.159L353.99 119.699C340.93 123.229 337.6 129.539 336.26 133.449L344.25 138.579V138.569Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39 133.159C358.39 133.159 364.5 129.519 366.64 123.849L362.44 116.489C362.44 116.489 358.79 121.519 354.96 122.699C354.96 122.699 359.53 117.859 359.97 114.149L357.46 113.739C357.46 113.739 354.34 119.079 348.87 121.959L358.38 133.169L358.39 133.159Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.53 121.999C365.53 121.999 361.87 127.009 358.35 129.709",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93 119.089C363.93 119.089 360.95 123.839 356.34 126.679",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.959 168.789L344.129 134.219L336.589 132.589C331.079 147.359 328.949 162.889 333.969 177.369L349.969 168.789H349.959Z",
    fill: "#DBA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.199 163.129L350.639 173.929",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1396 408.25H470.14",
    stroke: "#121D30",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1158_1505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472.27,
    height: 408.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.afec5cb286bdd2ea0675d275ae824a35.svg";
export { ForwardRef as ReactComponent };